export enum KameleoonFlagKey {
    newWelcomePage = 'cr_108_kameleoon_sbe_welcome_test',
    newLevelSelfAssessmentTest = '0010-la-section_german',
    lingobot = 'lingobot_web',
    printLessonMaterials = '_sbe_web__export_lesson_materials',
    grammarTrainer = 'grammar_trainer_web',
    grammarVideos = 'grammar_videos_web',
    onboardingReworkWeb = 'onboarding_rework_web',
    onboardingM2 = 'onboarding_m2',
    onboardingM2Pledge = 'onboarding_m2_pledge',
    mobileAppPromo = 'mobile_app_promo_web',
    lessonFlashcards = 'lesson_scoped_flashcards_web',
    practicePageRevamp = 'practice_page_revamp_web',
}

export type KameleoonFlagValue = 'on' | 'off' | 'control' | 'variant';

export type KameleoonFeatureFlags = Partial<Record<KameleoonFlagKey, KameleoonFlagValue>>;

export type UpdateKameleoonFeaturesList = (
    featuresParam:
        | KameleoonFeatureFlags
        | ((oldFeatures: KameleoonFeatureFlags) => KameleoonFeatureFlags),
) => void;

type KameleoonLoadingState = {
    status: 'loading';
};

type KameleoonFailedState = {
    status: 'failed';
};

type KameleoonInitializedState = {
    status: 'initialized';
    features: KameleoonFeatureFlags;
    visitorCode: string;
};

export type KameleoonState =
    | KameleoonLoadingState
    | KameleoonFailedState
    | KameleoonInitializedState;
